export default {
    props: {
        orderList: {
            type: Array
        },
        platform: { //平台: 0:用户端(默认),2:客户经理端
            type: Number,
            default: 0
        },
    },
    data(){
        return {
            alert: {
                isshow: false,
            },
        }
    },
    methods:{
        //后退
        customBack(){
            this.$emit("closeHistoryOrder");
        },
        handle(){
            this.$router.push({
                path: "/releaseSpecialJob",
                query: {

                }
            });
        },
    }
}


// WEBPACK FOOTER //
// ./src/shared/components/server/order-list.js